import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  to?: string;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  to,
  href,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary/90 shadow-sm',
    secondary: 'bg-secondary text-white hover:bg-secondary/90 shadow-sm',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white',
    ghost: 'text-primary hover:bg-primary/5',
    accent: 'bg-accent text-charcoal hover:bg-accent/90 shadow-sm'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base font-medium',
    lg: 'px-8 py-4 text-lg font-semibold'
  };
  const combinedClassName = cn('inline-flex items-center justify-center rounded-xl transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], className);
  if (to) {
    return <Link to={to} className={combinedClassName} data-id="element-21">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={combinedClassName} target="_blank" rel="noopener noreferrer" data-id="element-22">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-23">
      {children}
    </button>;
}